import { usePermissions } from 'react-admin';

const useIsAdmin = () => {
  const { permissions } = usePermissions();

  return () => {
    const accountPermissionGroups = permissions.permission_groups;
    return accountPermissionGroups?.some(({ role }) => role === 'admin');
  };
};

export default useIsAdmin;
